<template>
  <a @click="goBack" class="back">
    <img :src="svgWithColor" alt="Ícone de voltar" />
    Carteira de pesca
  </a>
</template>
<style scoped>
.back {
  color: v-bind(color); /* Atualizado para usar a prop color */
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.back img {
  height: 14px;
  margin-right: 5px;
}
</style>
<script>
export default {
  name: "BackBar",
  props: {
    color: {
      type: String,
      default: "#295661"
    }
  },
  computed: {
    svgWithColor() {
      return `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'><path d='M15 8.53906H1M1 8.53906L8 15.5391M1 8.53906L8 1.53906' stroke='${encodeURIComponent(
        this.color
      )}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>`;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
